
import { useTranslation } from 'react-i18next';
import ColdMeter  from './ColdMeter';
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import {ArrowLeft, ArrowRight, CloudRain} from 'react-bootstrap-icons';
import {useConfig} from "../helpers/useConfig";
import { c_or_f } from '../helpers/Utils';
import Lottie from "lottie-react";
import town from "../res/lottie/main_background_town_graphics.json";
const LatestNow = (props) => {
    const { t } = useTranslation();
    const [isShadow, setIsShadowShown] = useState(true);
    const [isSun, setIsSunShown] = useState(false);
    const [feelslike, setFeelslike] = useState(props.feelslike.avg);
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
     const {configData, setConfig} = useConfig();
    const showShadow = () =>{
        setIsShadowShown(true);
        setIsSunShown(false);
        setFeelslike(props.feelslike.avg);
    }
    const showSun = () =>{
        setIsShadowShown(false);
        setIsSunShown(true);
        setFeelslike(props.current.thsw);
    }
    function shouldShowSun () {
        return ((!props.cssClasses.includes("night")) && (props.current.issun) && (parseInt(props.current.thsw) > parseInt(props.feelslike.avg)));
    }
    const handleContent = () =>{
        if (screenWidth > 1460)
        {
            setIsSunShown(true);
            setIsShadowShown(true);
        }          
        else
        {
            setIsSunShown(false);
            setIsShadowShown(true);
        }
            
    }

    useEffect(() => {
        const handleResize = () => {
          setScreenWidth(window.innerWidth);
          handleContent();
          //alert(window.innerWidth);

        };
        handleResize();
        window.addEventListener('resize', handleResize);

        // Clean up the event listener when the component unmounts
        return () => {
          window.removeEventListener('resize', handleResize);
        };
        
      }, []); // Empty dependency array means this effect runs once on mount

    if (props.current === undefined)
        return "loading...";
    return (
          <div id="latestnow" className={"white_transp_box white_box " + (props.lang == 1? 'rtl' : '')}>
                <div id="innernow">
               
                <div  title="" className="mx-auto parambox">
               
                    <div className="primarytempValue">
                       <a href="#" className="highlow info">
                            {c_or_f(props.current.temp, configData.tempUnit)}°{(configData.tempUnit == 'F') ? 'F' : ''}
                            <span className="info">
                            {c_or_f(props.today.hightemp, configData.tempUnit)}°{(configData.tempUnit == 'F') ? 'F' : ''} ({props.today.hightemp_time})<br />
                            {c_or_f(props.today.lowtemp, configData.tempUnit)}°{(configData.tempUnit == 'F') ? 'F' : ''} ({props.today.lowtemp_time})
                            </span>
                        </a>

                        <div  id="windy">   
                        <div dangerouslySetInnerHTML={{__html: props.windstatus.lang1}}></div>
                        </div>
                    </div>
                    
                    
                </div>
                
                <Link to={`/Now`} img={(props.lang == 1)? "ArrowLeft" : "ArrowRight"}>
                        {(props.lang == 1)? <ArrowLeft /> : <ArrowRight />}
                        {t("MORE_INFO")} 
                </Link>
                               
                {(props.current.rainchance > 0) ?
                <div className="rainpercent">
                  <CloudRain />  {props.current.rainchance + "%"} 
                </div> :''}
                </div>
              
                <div id="coldmeterwrapper" className="float">
                     {((!isSun || (isSun && !isShadow)) && shouldShowSun()) ?
                    <ul id="sunshade_controls">
                            <li>
                                <label>
                                    <Link onClick={() => showShadow()} className={isShadow ? "selected" : ""}>{t("SHADE")}</Link>
                                </label>
                            </li>
                            <li>
                                <label>
                                    <Link onClick={() => showSun()} className={isSun ? "selected" : ""}>{t("IN_THE_SUN")}</Link>
                                </label>
                            </li>
                      </ul> : ''}
                 <div className="" id="itfeels">
                    
                </div>
                <ColdMeter  lang={props.lang} shadowtemp={props.feelslike.avg} suntemp={props.current.thsw} issun={props.current.issun} showShadow={isShadow} showSun={isSun && shouldShowSun()} />
                </div>
        </div>      
        
    );
}

export default LatestNow; 